import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2TrashOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M6 8H3V6h26v2h-3v18h-2V8H8v20h18l-1.4 2H6zm15-6H11v2h10z" /></svg>
);
